<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Danh mục sliders</strong>
          </div>
          <b-form @submit.prevent="search">
            <b-row>
              <b-col>
                <b-form-group
                  label="danh mục sliders:"
                  label-for="input-name"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                >
                  <b-form-input
                    type="text"
                    class="col-6"
                    id="input-name"
                    v-model="searchForm.str"
                    placeholder="Nhập tên hoặc mã ..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="" :label-cols="4">
                  <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <b-grid
            :searchForm="searchForm"
            :gridOptions="gridOptions"
            selectable
            dataUrl="system/slider-video-types"
            gridName="Danh sách danh mục sliders"
            ref="tagTable"
          >
            <template v-slot:actions>
              <router-link
                v-if="authorize(['ManageSliderVideoType'])"
                to="/system/slider-video-types/create"
                tag="button"
                class="btn btn-primary"
                size="md"
              >
                Thêm mới
              </router-link>
              <b-button
                v-if="authorize(['ManageSliderVideoType'])"
                size="md"
                @click.stop="deletes"
                variant="danger"
                :disabled="isDisabledDelete"
              >
                Xóa
              </b-button>
            </template>

            <template v-slot:cell(_actions)="row">
              <b-button-group>
                <b-button
                  v-if="authorize(['ViewSliderVideoType'])"
                  size="sm"
                  :to="{ path: `./detail/${row.item.id}` }"
                  title="xem"
                  variant="info"
                >
                  Xem
                </b-button>
                <template>
                  <b-button
                    v-if="authorize(['ManageSliderVideoType'])"
                    size="sm"
                    :to="{ path: `./edit/${row.item.id}` }"
                    title="sửa"
                    variant="primary"
                  >
                    Sửa
                  </b-button>
                  <b-button
                    v-if="authorize(['ManageSliderVideoType'])"
                    size="sm"
                    @click.stop="remove(row.item, row.index, $event.target)"
                    class="mr-1"
                    title="xóa"
                    variant="danger"
                  >
                    Xoá
                  </b-button>
                </template>
              </b-button-group>
            </template>
          </b-grid>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { authorizationMixin } from "@/shared/mixins";

export default {
  name: "Listtag",
  mixins: [authorizationMixin],
  data() {
    return {
      searchForm: {
        str: null,
      },
      isDisabledDelete: true,
      gridOptions: {
        fields: [
          {
            key: "slug",
            label: "Mã danh mục sliders",
            sortable: true,
            sortDirection: "asc",
          },
          {
            key: "name",
            label: "Tên danh mục sliders",
            sortable: true,
            sortDirection: "asc",
          },
          { key: "orderDisplay", label: "Số thứ tự hiển thị", sortable: true },
        ],
        sortBy: "orderDisplay",
      },
    };
  },
  computed: {},
  mounted() {
    this.$watch(
      () => {
        return this.$refs.tagTable.selectedRows;
      },
      (val) => {
        this.isDisabledDelete = val.length == 0;
      }
    );
  },
  created() {},
  methods: {
    search() {
      this.$refs.tagTable.refresh();
    },
    remove(item, index, button) {
      var vm = this;

      if (confirm("Bạn có chắc chắn muốn xóa danh mục sliders này?")) {
        this.$services
          .delete(`system/slider-video-types/${item.id}`)
          .done(() => {
            vm.$toastr.s("Xóa danh mục sliders thành công");
            vm.search();
          });
      }
    },
    deletes() {
      var vm = this;
      var selectedRows = this.$refs.tagTable.selectedRows;
      if (selectedRows.length > 0) {
        if (confirm("Bạn có chắc chắn muốn xóa các danh mục sliders này?")) {
          var data = selectedRows.map((x) => x.id).join(",");
          this.$services
            .delete(`system/slider-video-types?ids=${data}`)
            .done(() => {
              vm.$toastr.s("Xóa danh mục sliders thành công");
              vm.search();
            });
        }
      } else {
        vm.$toastr.e("Vui lòng chọn danh mục sliders cần xóa");
      }
    },
  },
};
</script>
<style scoped>
</style>
